import { Injectable, OnDestroy, signal, computed } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface PageHeaderConfig {
  title?: string;
  showBackButton?: boolean;
  backTo?: string;
}

// export interface ActionButton {
//   label: string;
//   icon?: string;
//   onClick?: () => void;
//   variant?: 'primary' | 'secondary' | 'danger';
//   disabled?: boolean;
//   hideLabel?: boolean;
//   subActions?: {
//     label: string;
//     icon?: string;
//     onClick: () => void;
//     variant?: 'primary' | 'secondary' | 'danger';
//     disabled?: boolean;
//   }[];
// }

@Injectable({
  providedIn: 'root',
})
export class PageHeaderService  {
  private config = signal<PageHeaderConfig>({});

  readonly title = computed(() => this.config().title ?? '');
  readonly showBackButton = computed(
    () => this.config().showBackButton ?? false
  );
  readonly backTo = computed(() => this.config().backTo ?? '');

  constructor(private router: Router) {
    // Auto-reset op route changes
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.reset());
  }

  setTitle(title: string) {
    this.config.set({ title });
  }

  setBackButton(showBackButton: boolean, backTo?: string) {
    this.config.set({ showBackButton, backTo });
  }

  updateConfig(newConfig: Partial<PageHeaderConfig>) {
    this.config.update((current) => ({
      ...current,
      ...newConfig,
    }));
  }

  reset() {
    this.config.set({});
  }
}
